// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaConnectionRect } from '../../interfaces/dna-syngovia-connection-rect';
import { AbstractChartMapService } from './abstract-chart-map.service';
import { ClientChartMapService } from './client-chart-map.service';

@Injectable({
  providedIn: 'root',
})
export class DICOMProxyChartMapService extends AbstractChartMapService {
  public constructor(
    private readonly clientChartMapService: ClientChartMapService,
  ) {
    super();
  }

  public override calculateRectValues(
    rects: DnaSyngoviaConnectionRect[],
    row: number,
    column: number,
  ): { row: number; column: number } | void {
    return this.clientChartMapService.calculateRectValues(rects, row, column);
  }

  protected override calculateLinePath(
    rect: DnaSyngoviaConnectionRect,
    row: number,
    column: number,
  ): string | null {
    return this.clientChartMapService['calculateLinePath'](rect, row, column);
  }
}
